/**
 * @generated SignedSource<<38980d4f0cbd75b39521468840f25b78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BrandTheme = "ROOTLY" | "ROOTLY_COBRAND" | "ROOTLY_HYBRID" | "TIERZERO" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type appMe$data = {
  readonly email: string;
  readonly firstName: string;
  readonly id: any;
  readonly isSuperAdmin: boolean;
  readonly lastName: string;
  readonly organization: {
    readonly appUrlDomain: string | null | undefined;
    readonly brandTheme: BrandTheme;
    readonly creditLimitResetAt: any | null | undefined;
    readonly enabledFeatureFlags: ReadonlyArray<string>;
    readonly id: any;
    readonly isSuspended: boolean;
    readonly name: string;
    readonly onboardingCompletedAt: any | null | undefined;
    readonly suspendedAt: any | null | undefined;
    readonly suspensionReason: string | null | undefined;
  };
  readonly pictureUrl: string | null | undefined;
  readonly role: string;
  readonly scopes: ReadonlyArray<string>;
  readonly teamContext: {
    readonly id: any;
    readonly team: {
      readonly id: any;
      readonly name: string;
    };
  } | null | undefined;
  readonly " $fragmentType": "appMe";
};
export type appMe$key = {
  readonly " $data"?: appMe$data;
  readonly " $fragmentSpreads": FragmentRefs<"appMe">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appMe",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pictureUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuperAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLOrganization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brandTheme",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSuspended",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "suspensionReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "suspendedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creditLimitResetAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appUrlDomain",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onboardingCompletedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabledFeatureFlags",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLUserTeamContext",
      "kind": "LinkedField",
      "name": "teamContext",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLTeam",
          "kind": "LinkedField",
          "name": "team",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLUser",
  "abstractKey": null
};
})();

(node as any).hash = "3b60e1d5afd1694f3d89cb5290af5d3a";

export default node;
